var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"text-box text-subtitle-1 font-weight-regular"},'span',_vm.$attrs,false),[(_vm.loading)?_c('v-skeleton-loader',{attrs:{"type":"text","width":_vm.width}}):_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }